import { registerVueComponentAndAngularBindings } from '/vodalys/vvuejs'
import VFigmaAnnounce from './VFigmaAnnounce.vue'

registerVueComponentAndAngularBindings('vfigma:announce', 'vfigmaAnnounce', VFigmaAnnounce)
